import { Component } from "@angular/core";

@Component({
  selector: "app-section-description",
  standalone: true,
  imports: [],
  templateUrl: "./section-description.component.html",
  styleUrls: ["./section-description.component.scss"],
})
export class SectionDescriptionComponent {}
